import styled from "@emotion/styled";

const HeaderWrapper = styled.div(({ isNavTop }) => ({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  ...(isNavTop ? { maxWidth: isNavTop, margin: "auto" } : {}),
}));

export default HeaderWrapper;
